/* eslint-disable react-hooks/exhaustive-deps */
import { BookingProvider, Path, Signal } from '@common/constans';
import { IPnrInfo, IRequest } from '@common/models';
import { IReservationHistorySearchQuery } from '@common/models/ReservationHistorySearchQuery';
import Button from '@components/general/form/Button';
import ReservationStatusForm from '@components/ReservationStatusForm';
import { AppAction, IAppAction } from '@misc/Action';
import { IAppState } from '@misc/State';
import Abort from '@service/Abort';
import { redirectToLogin } from '@service/Account';

import Config from '@service/Config';
import { Action, upcomingTrips } from '@service/proxy';
import Translate from '@service/Translate';
import { FC, Fragment, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import CurrentTrips from './CurrentTrips';
import SkeletonCurrentTrips from './SkeletonCurrentTrips';

interface IManageBookingTabPanelProps {
    className?: string;
}

const ManageBookingTabPanel: FC<IManageBookingTabPanelProps> = ({ className }) => {
    const { re, tr } = Translate;
    const { push } = useHistory();
    const dispatch = useDispatch();
    const [showUpcomingTripsLoading, setShowUpcomingTripsLoading] = useState<boolean>(false);
    const [currentTrips, setCurrentTrips] = useState<IPnrInfo[]>([]);
    const { user, showRetryButton } = useSelector((state: IAppState) => ({ user: state.user, showRetryButton: state.showRetryButton }));

    useEffect(() => {
        if (user.memberId)
            getUpcomingTripsItems();
    }, [user]);

    const getUpcomingTripsItems = () => {
        let request: IRequest<IReservationHistorySearchQuery> = {
            skip: 0,
            take: 2
        };
        let skeletonTimeout = setTimeout(() => {
            setShowUpcomingTripsLoading(true);
        }, 1000);
        dispatch<IAppAction>({ type: AppAction.ShowRetryButton, payload: { showRetryButton: false } });
        upcomingTrips(Action.POST, { data: request, signal: Abort.get(Signal.History).signal })
            .then((response) => {
                setCurrentTrips(response.content || []);
            })
            .catch(() => dispatch<IAppAction>({ type: AppAction.ShowRetryButton, payload: { showRetryButton: true } }))
            .finally(() => {
                clearTimeout(skeletonTimeout);
                setShowUpcomingTripsLoading(false);
            })
    }

    return (
        <div className={`manage-booking-tab-panel ${className ?? ""}`}>
            <div className="manage-booking-current-trips">
                {
                    Config.config.defaultBookingProvider === BookingProvider.Mahan ?
                        user.memberId ?
                            <Fragment>
                                <div className="current-trips-title flex flex-center justify-between">
                                    {
                                        !showRetryButton ?
                                            currentTrips.length || showUpcomingTripsLoading ? <h3>{tr("current_trips")}</h3>
                                                : <div className="error-current-trip">{tr("current_trips_msg_empty")}</div>
                                            : <div className="error-current-trip">{tr("err_current_trips")}</div>
                                    }
                                    <Button
                                        text={tr("my_trips_all")}
                                        color="blue"
                                        onClick={() => push(Path.Profile.History)}
                                        height="35px"
                                        width="auto"
                                    />
                                </div>
                                {
                                    showUpcomingTripsLoading ? <SkeletonCurrentTrips />
                                        : currentTrips.length ?
                                            <div className="current-trips-content">
                                                <CurrentTrips pnrInfo={currentTrips} />
                                            </div>
                                            : ""
                                }
                            </Fragment>
                            :
                            <h3 className="current-trips-login">
                                {re("current_trips_login",
                                    <Button
                                        color="blue"
                                        width="auto"
                                        text={tr("btn_login_register")}
                                        onClick={redirectToLogin}
                                    />
                                )}
                            </h3>
                        : ""
                }
            </div>
            <ReservationStatusForm orientation="horizontal" />
        </div>
    )
}

export default ManageBookingTabPanel;

